import sample_01 from './100_51338.jpg';

export const dynamicFlameAdvancedImpressions = {
    sample_01,
};
